import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {UserService} from "../../@shared/services/user.service";
import {environment} from "../../../environments/environment";
import {Router} from "@angular/router";
import {AuthUserService} from "../../@shared/services/auth/auth-user.service";
import {take} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private authWindow: Window | null = null;
  private authWindowInterval: any;
  public error$: Observable<string>;
  private error: BehaviorSubject<string>;

  constructor(private http: HttpClient,
              private userService: UserService,
              private route: Router,
              private authUser: AuthUserService
              // private jwtService: JwtService,
  ) {
    this.error = new BehaviorSubject('');
    this.error$ = this.error.asObservable();

  }

  public logout(): void {
    this.http.post(`${environment.GATEWAY_URL}/auth/logout`, {}).pipe(
      take(1),
    ).subscribe(async () => await this.authUser.logout());
  }

  public login(): void {
    // const token = this.jwtService.token;
    // const authUrl = `${environment.GATEWAY_URL}/auth/${provider}${token ? `?token=${token}` : ''}`;
    const authUrl = `${environment.GATEWAY_URL}/auth/steam`;
    if (this.authWindow) this.authWindow.close();
    const params = {
      width: 450,
      height: 600,
      resizable: 'yes',
      scrollbars: 'yes',
    };
    window.addEventListener('message', this.handleAuthResult, false);
    this.authWindow = window.open(authUrl, 'socialAuth', this.paramsToString(params));
    this.authWindow?.focus();
    this.authWindowInterval = setInterval(() => {
      if (this.authWindow?.closed) {
        this.cleanAuthMessageListener();
        clearInterval(this.authWindowInterval);
      }
    }, 1000);
  }


  private paramsToString(params: object): string {
    return Object.keys(params)
      // @ts-ignore
      .map(key => `${key}=${params[key]}`)
      .join(',');
  }

  private handleAuthResult = (message: {
    data: {
      event: string,
      provider: string,
      success: boolean
    }
  }): void => {
    const {success, event, provider} = message.data;
    if (provider) {
      this.cleanAuthMessageListener();
      if (success) {
        if (event === 'authentication') {
          this.authUser.requestProfile();
        }
      }
      this.authWindow?.close();
    }
  }

  private cleanAuthMessageListener(): void {
    window.removeEventListener('message', this.handleAuthResult);
  }


}
